export class PartnerType {
  id: string;
  description: string;
  type: string;
}



// WEBPACK FOOTER //
// ./src/classes/partnerType.ts